import { useQuery } from '@tanstack/react-query';
import { Balances } from '@solante/shared';
import { http } from '../api/http';
import { useClusterStore } from '../state/clusterStore';

export const useBalances = (wallet?: string | null) => {
  const cluster = useClusterStore((state) => state.cluster);

  return useQuery({
    queryKey: ['balances', wallet, cluster],
    enabled: Boolean(wallet),
    queryFn: () => http.get<{ balances: Balances }>(`/wallet/${wallet}?cluster=${cluster}`),
    select: (data) => data.balances,
    refetchInterval: 15_000,
  });
};
